import React, { useState } from "react";
import { useInView } from "react-intersection-observer";

import useGoogleAnalytics from "Hooks/useGoogleAnalytics";
import useSegment from "Hooks/useSegment";
import { createImpressionEvent, createClickEvent } from "Utilities/Instrumentation/Impressions/impressionGaEvents";
import { createViewedSegmentEvent, createClickedSegmentEvent } from "../../Utilities/Instrumentation/Impressions/impressionSegmentEvents";

const Frame = ({ children, sectionName, additionalViewedFuncs = [], additionalClickedFuncs = [], innerClassName, outerClassName, audience }) => {
  return (
    <ClickTrap sectionName={sectionName} additionalFuncs={additionalClickedFuncs} innerClassName={innerClassName} outerClassName={outerClassName} audience={audience} >
      <ViewedEvent sectionName={sectionName} additionalFuncs={additionalViewedFuncs} audience={audience}/>
      {children}
    </ClickTrap>
  );
};
const ViewedEvent = ({ sectionName, additionalFuncs = [], audience }) => {
  const [eventSent, setEventSent] = useState(false);
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();
  const { sendCustomSegmentTrackEvent } = useSegment();
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
    rootMargin: "0px 0px",
  });

  if (!sectionName) {
    console.error("Impression component needs the section name specified!");
    return false;
  }

  if (inView && !eventSent) {
    console.log(`Viewed: ${sectionName}`);
    sendGoogleAnalyticsEvent(createImpressionEvent(sectionName));
    sendCustomSegmentTrackEvent(createViewedSegmentEvent(sectionName, audience));
    for (let i = 0, ilen = additionalFuncs.length; i < ilen; i++) {
      additionalFuncs[i]()
    }
    setEventSent(true);
  }

  return <span ref={ref}></span>;
};

const ClickTrap = ({ sectionName, children, additionalFuncs = [], innerClassName, outerClassName, audience }) => {
  const [eventSent, setEventSent] = useState(false);
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();
  const { sendCustomSegmentTrackEvent } = useSegment();

  if (!sectionName) {
    console.error("Impression component needs the section name specified!");
    return false;
  }

  const handleOnClick = () => {
    if (!eventSent) {
      console.log(`Clicked: ${sectionName}`);
      sendGoogleAnalyticsEvent(createClickEvent(sectionName));
      sendCustomSegmentTrackEvent(createClickedSegmentEvent(sectionName, audience));
      for (let i = 0, ilen = additionalFuncs.length; i < ilen; i++) {
        additionalFuncs[i]()
      }
      setEventSent(true);
    }
  }

  return (
    <div
      style={{ pointerEvents: "none" }}
      className={outerClassName}
      onClick={handleOnClick}
    >
      <div className={innerClassName} style={{ pointerEvents: "auto" }}>{children}</div>
    </div>
  );
};

export default Frame;

export { ViewedEvent, ClickTrap };
